module.exports = __webpack_public_path__ + "static/img/AGL.00d6ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AGL.jpg
// module id = tIwp
// module chunks = 7